// Copyright (c) 2016 Deere & Company

import Dealer, {getDefaultState as getDefaultDealerState} from '@deere/cps-it.warranty-model-factory/lib/dealer';
import KeyValuePair, {getDefaultState as getDefaultKeyValuePairState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {getDefaultState as getDefaultDateRangeState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    claimType: KeyValuePair,
    creditMemoProcessDate: DateRange,
    pin: t.String,
    selectedDealer: Dealer,
    workOrderOne: t.String,
    workOrderTwo: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        claimType: getDefaultKeyValuePairState(),
        creditMemoProcessDate: getDefaultDateRangeState(),
        pin: '',
        selectedDealer: getDefaultDealerState(),
        workOrderOne: '',
        workOrderTwo: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/claim-history/state/criteria.js